// src/hooks/useFirestore.ts
import { useState, useEffect } from 'react';
import { doc, collection, onSnapshot } from 'firebase/firestore';
import { db, appId, firebaseInitialized } from '../constants/firebase';

export const useFirestore = (user: any) => {
  const [customers, setCustomers] = useState<any[]>([]);
  const [inventory, setInventory] = useState<any[]>([]);
  const [jobs, setJobs] = useState<any[]>([]);
  const [stringers, setStringers] = useState<any[]>([]); 
  const [testrackets, setTestrackets] = useState<any[]>([]);
  const [inbox, setInbox] = useState<any[]>([]);
  
  // NIEUW: companyLogo toegevoegd aan de state
  const [userProfile, setUserProfile] = useState({ companyName: '', companyLogo: '' });
  const [draftCompanyName, setDraftCompanyName] = useState('');
  const [customLinkId, setCustomLinkId] = useState('');
  const [draftLinkId, setDraftLinkId] = useState('');

  useEffect(() => {
    if (!user || !firebaseInitialized) return;

    // Fetch instellingen (bedrijfsnaam, linkId én logo)
    const userDocRef = doc(db, 'artifacts', appId, 'users', user.uid);
    const unsubUser = onSnapshot(userDocRef, (docSnap) => {
        if (docSnap.exists()) {
            const data = docSnap.data();
            setCustomLinkId(data.customLinkId || user.uid);
            setDraftLinkId(data.customLinkId || user.uid);
            
            const cName = data.companyName || user.displayName || 'Mijn Bespanservice';
            const cLogo = data.companyLogo || ''; // <-- NIEUW: Haal logo op
            
            setUserProfile({ companyName: cName, companyLogo: cLogo }); // <-- NIEUW: Sla logo op
            setDraftCompanyName(cName);
        } else {
            setCustomLinkId(user.uid);
            setDraftLinkId(user.uid);
            
            const cName = user.displayName || 'Mijn Bespanservice';
            setUserProfile({ companyName: cName, companyLogo: '' });
            setDraftCompanyName(cName);
        }
    });

    const qCustomers = collection(db, 'artifacts', appId, 'users', user.uid, 'customers');
    const unsubCustomers = onSnapshot(qCustomers, (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setCustomers(data.sort((a: any, b: any) => a.name.localeCompare(b.name)));
    });
    
    const qInventory = collection(db, 'artifacts', appId, 'users', user.uid, 'inventory');
    const unsubInventory = onSnapshot(qInventory, (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setInventory(data.sort((a: any, b: any) => {
            if (a.category === b.category) return a.brand.localeCompare(b.brand);
            return (a.category || '').localeCompare(b.category || '');
        }));
    });

    const qJobs = collection(db, 'artifacts', appId, 'users', user.uid, 'jobs');
    const unsubJobs = onSnapshot(qJobs, (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setJobs(data.sort((a: any, b: any) => new Date(b.date).getTime() - new Date(a.date).getTime()));
    });

    const qStringers = collection(db, 'artifacts', appId, 'users', user.uid, 'stringers');
    const unsubStringers = onSnapshot(qStringers, (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStringers(data.sort((a: any, b: any) => a.name.localeCompare(b.name)));
    });

    const qTestrackets = collection(db, 'artifacts', appId, 'users', user.uid, 'testrackets');
    const unsubTestrackets = onSnapshot(qTestrackets, (snapshot) => {
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTestrackets(data.sort((a: any, b: any) => (a.brand + a.model).localeCompare(b.brand + b.model)));
    });

    return () => { 
        unsubUser(); 
        unsubCustomers(); 
        unsubInventory(); 
        unsubJobs(); 
        unsubStringers(); 
        unsubTestrackets(); 
    };
  }, [user]);

  // Inbox ophalen (altijd uit je eigen veilige UID kluis)
  useEffect(() => {
      if (!user) return;
      const qInbox = collection(db, 'artifacts', appId, 'users', user.uid, 'inbox');
      
      const unsubInbox = onSnapshot(qInbox, (snapshot) => {
          const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setInbox(data.sort((a: any, b: any) => (b.createdAt || 0) - (a.createdAt || 0)));
      });
      return () => unsubInbox();
  }, [user]);

  return {
    customers, setCustomers,
    inventory, setInventory,
    jobs, setJobs,
    stringers, setStringers,
    testrackets, setTestrackets,
    inbox, setInbox,
    userProfile, setUserProfile,
    draftCompanyName, setDraftCompanyName,
    customLinkId, setCustomLinkId,
    draftLinkId, setDraftLinkId
  };
};